// Third party
import React, { useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

// Components
import LegacyEditBMOGIFPortfolioHolding from './LegacyEditBMOGIFPortfolioHolding';

// Utils
import BMOGIFPortfolioHolding from '@/types/bmo-gif/bmo-gif-portfolio-holding';

interface LegacyBMOGIFHoldingsContainerProps {
  holdings: BMOGIFPortfolioHolding[];
  changeHoldingWeight: (id: string, value: number) => void;
  customTemplate?: boolean;
  onScrollDown: () => void;
  onScrollUp: () => void;
  onYReachEnd: () => void;
  onYReachStart: () => void;
  readOnly?: boolean;
  removeHoldingFromGifPortfolioById: (holding: BMOGIFPortfolioHolding) => void;
}

const LegacyBMOGIFHoldingsContainer: React.FC<LegacyBMOGIFHoldingsContainerProps> = ({
  holdings,
  changeHoldingWeight,
  customTemplate = false,
  onScrollDown,
  onScrollUp,
  onYReachEnd,
  onYReachStart,
  readOnly = false,
  removeHoldingFromGifPortfolioById,
}) => {
  const containerRef = useRef<PerfectScrollbar | null>(null);

  return (
    <PerfectScrollbar
      className="bmo-gif-portfolio-holdings-container"
      onYReachStart={onYReachStart}
      onYReachEnd={onYReachEnd}
      onScrollDown={onScrollDown}
      onScrollUp={onScrollUp}
      ref={containerRef}
    >
      <div className="bmo-gif-portfolio-holdings">
        {holdings.map(holding => (
          <LegacyEditBMOGIFPortfolioHolding
            key={holding.id}
            portfolioHolding={holding}
            onRemoveHolding={removeHoldingFromGifPortfolioById}
            onWeightChange={changeHoldingWeight}
            readOnly={readOnly}
            customTemplate={customTemplate}
          />
        ))}
      </div>
    </PerfectScrollbar>
  );
};

export default LegacyBMOGIFHoldingsContainer;
